"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGroupHighchartsDrillEvent = void 0;
function isGroupHighchartsDrillEvent(event) {
    return !!event.points;
}
exports.isGroupHighchartsDrillEvent = isGroupHighchartsDrillEvent;
//# sourceMappingURL=isGroupHighchartsDrillEvent.js.map